// @ts-ignore
import TagManager from "react-gtm-module";

const tagManagerEvents = (eventName: string, utm_source?: string): void => {
  const tagManagerArgs = {
    dataLayer: {
      event: eventName,
      utm_source: utm_source,
    },
  };
  TagManager.dataLayer(tagManagerArgs);
};

export const AwarenessTagManagerEvents = (data: any) => {
  const tagManagerArgs = {
    dataLayer: data,
  };
  TagManager.dataLayer(tagManagerArgs);
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const landingTagMangerEvent = (
  eventName: string,
  utm_source?: string,
): void => {};

export default tagManagerEvents;
